var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconExport = function SvgIconExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9v7H2V9H0v7a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V9Zm-6 .7 2.6-2.6L14 8.5l-5 5-5-5 1.4-1.4L8 9.7V0h2Z"
  })));
};
export default SvgIconExport;